import request from '@/utils/api.request'

export function postApply(data) {
  return request({
    url: `/tenants`,
    method: 'post',
    data,
  })
}